import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=0c5e2684&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"
import style0 from "./IndexView.vue?vue&type=style&index=0&id=0c5e2684&prod&lang=scss&scoped=true"
import style1 from "./IndexView.vue?vue&type=style&index=1&id=0c5e2684&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e2684",
  null
  
)

export default component.exports